"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[10102],{

/***/ 609705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ NodeSelectorType; }
/* harmony export */ });
var NodeSelectorType = /* @__PURE__ */ ((NodeSelectorType2) => {
  NodeSelectorType2[NodeSelectorType2["Any"] = 0] = "Any";
  NodeSelectorType2[NodeSelectorType2["Id"] = 1] = "Id";
  NodeSelectorType2[NodeSelectorType2["Obj"] = 2] = "Obj";
  return NodeSelectorType2;
})(NodeSelectorType || {});




/***/ }),

/***/ 483011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ deprecateCanvasComponent; },
/* harmony export */   "X": function() { return /* binding */ Canvas; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(182052);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _Element_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(945607);





var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const deprecateCanvasComponent = () => (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_2__/* .deprecationWarning */ .d)("<Canvas />", {
  suggest: "<Element canvas={true} />"
});
function Canvas(_a) {
  var props = __objRest(_a, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => deprecateCanvasComponent(), []);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Element_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Element */ .W_, __spreadProps(__spreadValues({}, props), {
    canvas: true
  }));
}




/***/ }),

/***/ 945607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W_": function() { return /* binding */ Element; },
  "WP": function() { return /* binding */ defaultElementProps; },
  "D5": function() { return /* binding */ elementPropToNodeData; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/useEffectOnce.es.js
const r=r=>{(0,react.useEffect)(r,[])};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/constants.es.js
var constants_es = __webpack_require__(60599);
// EXTERNAL MODULE: ../../.yarn/cache/tiny-invariant-npm-1.2.0-024338c59c-e09a718a7c.zip/node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var tiny_invariant_esm = __webpack_require__(668564);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/NodeElement.es.js + 3 modules
var NodeElement_es = __webpack_require__(773855);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/useInternalNode.es.js
var useInternalNode_es = __webpack_require__(131817);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/useInternalEditor.es.js
var useInternalEditor_es = __webpack_require__(210289);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/Element.es.js








var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultElementProps = {
  is: "div",
  canvas: false,
  custom: {},
  hidden: false
};
const elementPropToNodeData = {
  is: "type",
  canvas: "isCanvas"
};
function Element(_a) {
  var _b = _a, {
    id,
    children
  } = _b, elementProps = __objRest(_b, [
    "id",
    "children"
  ]);
  const { is } = __spreadValues(__spreadValues({}, defaultElementProps), elementProps);
  const { query, actions } = (0,useInternalEditor_es/* useInternalEditor */._)();
  const { node, inNodeContext } = (0,useInternalNode_es/* useInternalNode */.Z)((node2) => ({
    node: {
      id: node2.id,
      data: node2.data
    }
  }));
  const [linkedNodeId, setLinkedNodeId] = (0,react.useState)(null);
  r(() => {
    (0,tiny_invariant_esm/* default */.Z)(!!id, constants_es/* ERROR_TOP_LEVEL_ELEMENT_NO_ID */.VW);
    const { id: nodeId, data } = node;
    if (inNodeContext) {
      let linkedNodeId2;
      const existingNode = data.linkedNodes && data.linkedNodes[id] && query.node(data.linkedNodes[id]).get();
      if (existingNode && existingNode.data.type === is) {
        linkedNodeId2 = existingNode.id;
      } else {
        const linkedElement = react.createElement(
          Element,
          elementProps,
          children
        );
        const tree = query.parseReactElement(linkedElement).toNodeTree();
        linkedNodeId2 = tree.rootNodeId;
        actions.history.ignore().addLinkedNodeFromTree(tree, nodeId, id);
      }
      setLinkedNodeId(linkedNodeId2);
    }
  });
  return linkedNodeId ? /* @__PURE__ */ (0,jsx_runtime.jsx)(NodeElement_es/* NodeElement */.V, {
    id: linkedNodeId
  }) : null;
}




/***/ }),

/***/ 879577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ LAZY_RENDERING_CONFIG; },
/* harmony export */   "U": function() { return /* binding */ LazyNodeElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _NodeElement_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(773855);
/* harmony import */ var _ViewportContext_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(814409);





const LAZY_RENDERING_CONFIG = {
  ROOT_MARGIN: "200px",
  THRESHOLD: 0.01
};
const requestIdle = (cb) => {
  if (typeof requestIdleCallback !== "undefined") {
    return requestIdleCallback(cb);
  }
  return window.setTimeout(cb, 2e3);
};
const cancelIdle = (id) => {
  if (typeof cancelIdleCallback !== "undefined") {
    cancelIdleCallback(id);
  } else {
    clearTimeout(id);
  }
};
const LazyNodeElement = ({
  id,
  render,
  placeholderHeight,
  forceRender = false
}) => {
  const { lazyRenderingEnabled, viewportRoot } = (0,_ViewportContext_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useViewport */ .S)();
  const shouldForce = forceRender || !lazyRenderingEnabled;
  const [hasRendered, setHasRendered] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(shouldForce);
  const placeholderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const idleCallbackRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (hasRendered)
      return;
    const element = placeholderRef.current;
    if (!element)
      return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (idleCallbackRef.current !== null) {
              cancelIdle(idleCallbackRef.current);
              idleCallbackRef.current = null;
            }
            setHasRendered(true);
            observer.disconnect();
          } else {
            if (idleCallbackRef.current === null) {
              idleCallbackRef.current = requestIdle(() => {
                idleCallbackRef.current = null;
                setHasRendered(true);
              });
            }
          }
        });
      },
      {
        root: viewportRoot,
        rootMargin: LAZY_RENDERING_CONFIG.ROOT_MARGIN,
        threshold: LAZY_RENDERING_CONFIG.THRESHOLD
      }
    );
    observer.observe(element);
    return () => {
      observer.disconnect();
      if (idleCallbackRef.current !== null) {
        cancelIdle(idleCallbackRef.current);
        idleCallbackRef.current = null;
      }
    };
  }, [viewportRoot, hasRendered]);
  if (!hasRendered) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      ref: placeholderRef,
      "data-lazy-node-id": id,
      style: {
        minHeight: placeholderHeight || "auto",
        visibility: "hidden"
      }
    });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_NodeElement_es_js__WEBPACK_IMPORTED_MODULE_3__/* .NodeElement */ .V, {
    id,
    render
  });
};




/***/ }),

/***/ 766911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ NodeProvider; },
/* harmony export */   "s": function() { return /* binding */ NodeContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



const NodeContext = react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);
const NodeProvider = ({ id, related = false, children }) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NodeContext.Provider, {
    value: { id, related },
    children
  });
};




/***/ }),

/***/ 773855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ NodeElement; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/NodeContext.es.js
var NodeContext_es = __webpack_require__(766911);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/hooks/useNode.es.js
var useNode_es = __webpack_require__(883700);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/render/SimpleElement.es.js



const SimpleElement = ({ render }) => {
  const {
    connectors: { connect, drag }
  } = (0,useNode_es/* useNode */.Z)();
  return typeof render.type === "string" ? connect(drag(react.cloneElement(render))) : render;
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/LazyNodeElement.es.js
var LazyNodeElement_es = __webpack_require__(879577);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/useInternalNode.es.js
var useInternalNode_es = __webpack_require__(131817);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/editor/useInternalEditor.es.js
var useInternalEditor_es = __webpack_require__(210289);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/render/DefaultRender.es.js







const DefaultRender = () => {
  const { type, props, nodes, hydrationTimestamp } = (0,useInternalNode_es/* useInternalNode */.Z)(
    (node) => ({
      type: node.data.type,
      props: node.data.props,
      nodes: node.data.nodes,
      hydrationTimestamp: node._hydrationTimestamp
    })
  );
  const childrenLazyRenderFlags = (0,useInternalEditor_es/* useInternalEditor */._)((state) => {
    if (!nodes || nodes.length === 0)
      return {};
    const flags = {};
    nodes.forEach((id) => {
      var _a;
      const node = state.nodes[id];
      if (!(node == null ? void 0 : node.data))
        return;
      flags[id] = ((_a = node.data.custom) == null ? void 0 : _a.lazyRender) === false;
    });
    return flags;
  });
  return (0,react.useMemo)(() => {
    if (!type)
      return /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {});
    let render = react.createElement(type, props, props == null ? void 0 : props.children);
    if (nodes && nodes.length > 0) {
      render = react.createElement(
        type,
        props,
        ...nodes.map((id) => {
          const forceEager = childrenLazyRenderFlags[id] === true;
          return /* @__PURE__ */ (0,jsx_runtime.jsx)(LazyNodeElement_es/* LazyNodeElement */.U, {
            id,
            forceRender: forceEager
          }, id);
        })
      );
    }
    if (typeof type == "string") {
      return /* @__PURE__ */ (0,jsx_runtime.jsx)(SimpleElement, {
        render
      });
    }
    return render;
  }, [type, props, hydrationTimestamp, nodes, childrenLazyRenderFlags]);
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/render/RenderNode.es.js






const RenderNodeToElement = ({ render }) => {
  const { hidden } = (0,useInternalNode_es/* useInternalNode */.Z)((node) => ({
    hidden: node.data.hidden
  }));
  const { onRender } = (0,useInternalEditor_es/* useInternalEditor */._)((state) => ({
    onRender: state.options.onRender
  }));
  if (hidden) {
    return null;
  }
  return react.createElement(onRender, { render: render || /* @__PURE__ */ (0,jsx_runtime.jsx)(DefaultRender, {}) });
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/render/PerformanceTracker.es.js
var PerformanceTracker_es = __webpack_require__(566414);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-core-virtual-a203456ea6/0/cache/@tempi-dnd-core-npm-1.6.1-UX4BUYER-8801.0-ea34d0752a-5aad5b47dc.zip/node_modules/@tempi/dnd-core/dist/nodes/NodeElement.es.js






const NodeElement = ({ id, render }) => {
  (0,react.useEffect)(() => {
    if (PerformanceTracker_es/* PerformanceTracker.enabled */.a.enabled) {
      PerformanceTracker_es/* PerformanceTracker.incrementNodeCount */.a.incrementNodeCount();
    }
  }, [id]);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(NodeContext_es/* NodeProvider */.c, {
    id,
    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(RenderNodeToElement, {
      render
    })
  });
};




/***/ }),

/***/ 814409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useViewport; },
/* harmony export */   "j": function() { return /* binding */ ViewportProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



const ViewportContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  viewportRoot: null,
  lazyRenderingEnabled: false
});
const ViewportProvider = ({ children, viewportRoot, lazyRenderingEnabled }) => {
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ViewportContext.Provider, {
    value: { viewportRoot, lazyRenderingEnabled },
    children
  });
};
const useViewport = () => (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ViewportContext);




/***/ }),

/***/ 131817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInternalNode; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60599);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(786342);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var tiny_invariant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(668564);
/* harmony import */ var _NodeContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(766911);
/* harmony import */ var _editor_useInternalEditor_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(210289);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function useInternalNode(collect) {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_NodeContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .NodeContext */ .s);
  (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(context, _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__/* .ERROR_USE_NODE_OUTSIDE_OF_EDITOR_CONTEXT */ .pY);
  const { id, related } = context;
  const _a = (0,_editor_useInternalEditor_es_js__WEBPACK_IMPORTED_MODULE_4__/* .useInternalEditor */ ._)(
    (state) => id && state.nodes[id] && collect && collect(state.nodes[id])
  ), {
    actions: EditorActions,
    query,
    connectors: editorConnectors
  } = _a, collected = __objRest(_a, [
    "actions",
    "query",
    "connectors"
  ]);
  const connectors = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_5__/* .wrapConnectorHooks */ .p)({
      connect: (dom) => editorConnectors.connect(dom, id),
      drag: (dom) => editorConnectors.drag(dom, id)
    }),
    [editorConnectors, id]
  );
  const actions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return {
      setProp: (cb, throttleRate) => {
        if (throttleRate) {
          EditorActions.history.throttle(throttleRate).setProp(id, cb);
        } else {
          EditorActions.setProp(id, cb);
        }
      },
      setCustom: (cb, throttleRate) => {
        if (throttleRate) {
          EditorActions.history.throttle(throttleRate).setCustom(id, cb);
        } else {
          EditorActions.setCustom(id, cb);
        }
      },
      setHidden: (bool) => EditorActions.setHidden(id, bool)
    };
  }, [EditorActions, id]);
  return __spreadProps(__spreadValues({}, collected), {
    id,
    related,
    inNodeContext: !!context,
    actions,
    connectors
  });
}




/***/ }),

/***/ 576344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ Frame; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60599);
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(182052);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _editor_useInternalEditor_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(210289);
/* harmony import */ var _nodes_NodeElement_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(773855);
/* harmony import */ var _nodes_ViewportContext_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(814409);
/* harmony import */ var _PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(566414);








const RenderRootNode = () => {
  const { timestamp } = (0,_editor_useInternalEditor_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useInternalEditor */ ._)((state) => ({
    timestamp: state.nodes[_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__/* .ROOT_NODE */ .QS] && state.nodes[_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__/* .ROOT_NODE */ .QS]._hydrationTimestamp
  }));
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (_PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.enabled */ .a.enabled && timestamp) {
      _PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.markAllNodesCreated */ .a.markAllNodesCreated();
      requestAnimationFrame(() => {
        _PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.markEffectsStart */ .a.markEffectsStart();
        const timeoutId = setTimeout(() => {
          _PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.markEffectsComplete */ .a.markEffectsComplete();
          _PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.complete */ .a.complete();
        }, 200);
        return () => clearTimeout(timeoutId);
      });
    }
  }, [timestamp]);
  if (!timestamp) {
    return null;
  }
  if (_PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.enabled */ .a.enabled) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Profiler, {
      id: "tempi-editor-root",
      onRender: (_id, phase, actualDuration) => _PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.recordPhase */ .a.recordPhase(phase, actualDuration),
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nodes_NodeElement_es_js__WEBPACK_IMPORTED_MODULE_5__/* .NodeElement */ .V, {
        id: _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__/* .ROOT_NODE */ .QS
      }, timestamp)
    });
  }
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nodes_NodeElement_es_js__WEBPACK_IMPORTED_MODULE_5__/* .NodeElement */ .V, {
    id: _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__/* .ROOT_NODE */ .QS
  }, timestamp);
};
const Frame = ({
  children,
  json,
  data,
  onRendered,
  enableLazyRendering = false,
  viewportRoot = null
}) => {
  const { actions, query } = (0,_editor_useInternalEditor_es_js__WEBPACK_IMPORTED_MODULE_2__/* .useInternalEditor */ ._)();
  if (!!json) {
    (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_6__/* .deprecationWarning */ .d)("<Frame json={...} />", {
      suggest: "<Frame data={...} />"
    });
  }
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    onRendered == null ? void 0 : onRendered();
  }, []);
  const initialState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({
    initialChildren: children,
    initialData: data || json
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    const { initialChildren, initialData } = initialState.current;
    _PerformanceTracker_es_js__WEBPACK_IMPORTED_MODULE_4__/* .PerformanceTracker.init */ .a.init();
    if (initialData) {
      actions.history.ignore().deserialize(initialData);
    } else if (initialChildren) {
      const rootNode = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(
        initialChildren
      );
      const node = query.parseReactElement(rootNode).toNodeTree((node2, jsx2) => {
        if (jsx2 === rootNode) {
          node2.id = _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_3__/* .ROOT_NODE */ .QS;
        }
        return node2;
      });
      actions.history.ignore().addNodeTree(node);
    }
  }, [actions, query]);
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nodes_ViewportContext_es_js__WEBPACK_IMPORTED_MODULE_7__/* .ViewportProvider */ .j, {
    viewportRoot,
    lazyRenderingEnabled: enableLazyRendering,
    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RenderRootNode, {})
  });
};




/***/ }),

/***/ 566414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ PerformanceTracker; }
/* harmony export */ });
class PerformanceTrackerClass {
  constructor() {
    this.metrics = null;
    this.nodeCount = 0;
    this.isEnabled = false;
    this.nodeRenderTimes = [];
    this.firstNodeTime = null;
    this.effectsStartTime = null;
  }
  init() {
    var _a;
    if (typeof window === "undefined")
      return;
    this.isEnabled = ((_a = window == null ? void 0 : window.config) == null ? void 0 : _a.enableLogPerformance) === true;
    if (this.isEnabled) {
      this.reset();
    }
  }
  reset() {
    this.metrics = {
      totalNodes: 0,
      totalRenderTime: 0,
      startTime: performance.now(),
      phases: {
        mount: 0,
        update: 0
      },
      milestones: {},
      nodeTimings: {
        fastest: Infinity,
        slowest: 0,
        p50: 0,
        p95: 0
      }
    };
    this.nodeCount = 0;
    this.nodeRenderTimes = [];
    this.firstNodeTime = null;
    this.effectsStartTime = null;
  }
  incrementNodeCount() {
    if (!this.isEnabled || !this.metrics)
      return;
    this.nodeCount++;
    this.metrics.totalNodes = this.nodeCount;
    if (!this.firstNodeTime) {
      this.firstNodeTime = performance.now();
      this.metrics.milestones.firstNodeRendered = this.firstNodeTime - this.metrics.startTime;
    }
  }
  recordPhase(phase, duration) {
    if (!this.isEnabled || !this.metrics)
      return;
    this.metrics.phases[phase] += duration;
    this.metrics.totalRenderTime += duration;
    this.nodeRenderTimes.push(duration);
    if (duration < this.metrics.nodeTimings.fastest) {
      this.metrics.nodeTimings.fastest = duration;
    }
    if (duration > this.metrics.nodeTimings.slowest) {
      this.metrics.nodeTimings.slowest = duration;
    }
  }
  markAllNodesCreated() {
    if (!this.isEnabled || !this.metrics)
      return;
    this.metrics.milestones.allNodesCreated = performance.now() - this.metrics.startTime;
  }
  markEffectsStart() {
    if (!this.isEnabled)
      return;
    this.effectsStartTime = performance.now();
  }
  markEffectsComplete() {
    if (!this.isEnabled || !this.metrics)
      return;
    const now = performance.now();
    this.metrics.milestones.effectsComplete = now - this.metrics.startTime;
    if (this.effectsStartTime !== null) {
      this.metrics.milestones.effectsDuration = now - this.effectsStartTime;
    }
  }
  calculatePercentiles() {
    if (!this.metrics || this.nodeRenderTimes.length === 0)
      return;
    const sorted = [...this.nodeRenderTimes].sort((a, b) => a - b);
    const p50Index = Math.floor(sorted.length * 0.5);
    const p95Index = Math.floor(sorted.length * 0.95);
    this.metrics.nodeTimings.p50 = sorted[p50Index] || 0;
    this.metrics.nodeTimings.p95 = sorted[p95Index] || 0;
  }
  complete() {
    if (!this.isEnabled || !this.metrics)
      return;
    this.metrics.endTime = performance.now();
    const totalTime = this.metrics.endTime - this.metrics.startTime;
    this.calculatePercentiles();
    const idleTime = totalTime - this.metrics.totalRenderTime;
    const idlePercentage = idleTime / totalTime * 100;
    console.group("\u{1F3A8} [Tempi Editor] Ch\u1EC9 s\u1ED1 hi\u1EC7u n\u0103ng render");
    console.group("\u{1F4CA} T\u1ED5ng quan");
    console.log("T\u1ED5ng s\u1ED1 node \u0111\xE3 render:", this.metrics.totalNodes);
    console.log(
      "T\u1ED5ng th\u1EDDi gian tr\xF4i qua (th\u1EF1c t\u1EBF):",
      `${totalTime.toFixed(2)}ms`
    );
    console.log(
      "T\u1ED5ng th\u1EDDi gian render (CPU):",
      `${this.metrics.totalRenderTime.toFixed(2)}ms`
    );
    console.log(
      "\u23F1\uFE0F Th\u1EDDi gian ch\u1EDD/idle:",
      `${idleTime.toFixed(2)}ms (${idlePercentage.toFixed(1)}%)`
    );
    console.groupEnd();
    console.group("\u26A1 Ph\xE2n t\xEDch giai \u0111o\u1EA1n");
    console.log(
      "Giai \u0111o\u1EA1n mount (t\u1EA1o m\u1EDBi):",
      `${this.metrics.phases.mount.toFixed(2)}ms`
    );
    console.log(
      "Giai \u0111o\u1EA1n update (c\u1EADp nh\u1EADt):",
      `${this.metrics.phases.update.toFixed(2)}ms`
    );
    console.groupEnd();
    if (Object.keys(this.metrics.milestones).length > 0) {
      console.group("\u{1F3C1} C\xE1c m\u1ED1c th\u1EDDi gian");
      if (this.metrics.milestones.firstNodeRendered) {
        console.log(
          "Node \u0111\u1EA7u ti\xEAn:",
          `${this.metrics.milestones.firstNodeRendered.toFixed(2)}ms`
        );
      }
      if (this.metrics.milestones.allNodesCreated) {
        console.log(
          "T\u1EA5t c\u1EA3 nodes \u0111\xE3 t\u1EA1o:",
          `${this.metrics.milestones.allNodesCreated.toFixed(2)}ms`
        );
      }
      if (this.metrics.milestones.effectsComplete) {
        console.log(
          "Effects ho\xE0n th\xE0nh:",
          `${this.metrics.milestones.effectsComplete.toFixed(2)}ms`
        );
      }
      if (this.metrics.milestones.effectsDuration !== void 0) {
        console.log(
          "Th\u1EDDi gian ch\u1EA1y effects:",
          `${this.metrics.milestones.effectsDuration.toFixed(2)}ms`
        );
      }
      console.groupEnd();
    }
    console.group("\u{1F4C8} Th\u1ED1ng k\xEA node render");
    console.log(
      "Trung b\xECnh m\u1ED7i node:",
      `${(this.metrics.totalRenderTime / this.metrics.totalNodes).toFixed(
        2
      )}ms`
    );
    console.log(
      "Node nhanh nh\u1EA5t:",
      `${this.metrics.nodeTimings.fastest.toFixed(2)}ms`
    );
    console.log(
      "Node ch\u1EADm nh\u1EA5t:",
      `${this.metrics.nodeTimings.slowest.toFixed(2)}ms`
    );
    console.log(
      "Percentile 50% (median):",
      `${this.metrics.nodeTimings.p50.toFixed(2)}ms`
    );
    console.log(
      "Percentile 95%:",
      `${this.metrics.nodeTimings.p95.toFixed(2)}ms`
    );
    console.groupEnd();
    console.groupEnd();
  }
  getMetrics() {
    return this.metrics;
  }
  get enabled() {
    return this.isEnabled;
  }
}
const PerformanceTracker = new PerformanceTrackerClass();




/***/ }),

/***/ 886968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ createNode; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(596301);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _nodes_NodeContext_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(766911);
/* harmony import */ var _nodes_Element_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(945607);
/* harmony import */ var _nodes_Canvas_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(483011);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getNodeTypeName = (type) => typeof type == "string" ? type : type.name;
function createNode(newNode, normalize) {
  let actualType = newNode.data.type;
  const id = newNode.id || (0,_tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .getRandomId */ .w)();
  const node = {
    id,
    _hydrationTimestamp: Date.now(),
    data: __spreadValues({
      type: actualType,
      name: getNodeTypeName(actualType),
      displayName: getNodeTypeName(actualType),
      props: {},
      custom: {},
      parent: null,
      isCanvas: false,
      hidden: false,
      nodes: [],
      linkedNodes: {}
    }, newNode.data),
    related: {},
    events: {
      selected: false,
      dragged: false,
      hovered: false
    },
    rules: {
      canDrag: () => true,
      canDrop: () => true,
      canMoveIn: () => true,
      canMoveOut: () => true
    },
    dom: null
  };
  if (node.data.type === _nodes_Element_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Element */ .W_ || node.data.type === _nodes_Canvas_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Canvas */ .X) {
    const mergedProps = __spreadValues(__spreadValues({}, _nodes_Element_es_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultElementProps */ .WP), node.data.props);
    node.data.props = Object.keys(node.data.props).reduce((props, key) => {
      if (Object.keys(_nodes_Element_es_js__WEBPACK_IMPORTED_MODULE_2__/* .defaultElementProps */ .WP).includes(key)) {
        node.data[_nodes_Element_es_js__WEBPACK_IMPORTED_MODULE_2__/* .elementPropToNodeData */ .D5[key] || key] = mergedProps[key];
      } else {
        props[key] = node.data.props[key];
      }
      return props;
    }, {});
    actualType = node.data.type;
    node.data.name = getNodeTypeName(actualType);
    node.data.displayName = getNodeTypeName(actualType);
    const usingDeprecatedCanvas = node.data.type === _nodes_Canvas_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Canvas */ .X;
    if (usingDeprecatedCanvas) {
      node.data.isCanvas = true;
      (0,_nodes_Canvas_es_js__WEBPACK_IMPORTED_MODULE_3__/* .deprecateCanvasComponent */ .O)();
    }
  }
  if (normalize) {
    normalize(node);
  }
  const userComponentConfig = actualType.craft;
  if (userComponentConfig) {
    node.data.displayName = userComponentConfig.displayName || userComponentConfig.name || node.data.displayName;
    node.data.props = __spreadValues(__spreadValues({}, userComponentConfig.props || userComponentConfig.defaultProps || {}), node.data.props);
    node.data.custom = __spreadValues(__spreadValues({}, userComponentConfig.custom || {}), node.data.custom);
    if (userComponentConfig.isCanvas !== void 0 && userComponentConfig.isCanvas !== null) {
      node.data.isCanvas = userComponentConfig.isCanvas;
    }
    if (userComponentConfig.rules) {
      Object.keys(userComponentConfig.rules).forEach((key) => {
        if (["canDrag", "canDrop", "canMoveIn", "canMoveOut"].includes(key)) {
          node.rules[key] = userComponentConfig.rules[key];
        }
      });
    }
    if (userComponentConfig.related) {
      const relatedNodeContext = {
        id: node.id,
        related: true
      };
      Object.keys(userComponentConfig.related).forEach((comp) => {
        node.related[comp] = () => react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          _nodes_NodeContext_es_js__WEBPACK_IMPORTED_MODULE_4__/* .NodeProvider */ .c,
          relatedNodeContext,
          react__WEBPACK_IMPORTED_MODULE_0__.createElement(userComponentConfig.related[comp])
        );
      });
    }
  }
  return node;
}




/***/ }),

/***/ 889374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ deserializeNode; }
/* harmony export */ });
/* unused harmony export deserializeComp */
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60599);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var tiny_invariant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(668564);
/* harmony import */ var _resolveComponent_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(798154);
/* harmony import */ var _nodes_Canvas_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(483011);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const restoreType = (type, resolver) => typeof type === "object" && type.resolvedName ? type.resolvedName === "Canvas" ? _nodes_Canvas_es_js__WEBPACK_IMPORTED_MODULE_1__/* .Canvas */ .X : resolver[type.resolvedName] : typeof type === "string" ? type : null;
const deserializeComp = (data, resolver, index) => {
  let { props } = data;
  const { type } = data;
  const main = restoreType(type, resolver);
  if (!main) {
    return;
  }
  props = Object.keys(props).reduce((result, key) => {
    const prop = props[key];
    if (prop === null || prop === void 0) {
      result[key] = null;
    } else if (typeof prop === "object" && prop.resolvedName) {
      result[key] = deserializeComp(prop, resolver);
    } else if (key === "children" && Array.isArray(prop)) {
      result[key] = prop.map((child) => {
        if (typeof child === "string") {
          return child;
        }
        return deserializeComp(child, resolver);
      });
    } else {
      result[key] = prop;
    }
    return result;
  }, {});
  if (index) {
    props.key = index;
  }
  const jsx = __spreadValues({}, react__WEBPACK_IMPORTED_MODULE_0__.createElement(main, __spreadValues({}, props)));
  return __spreadProps(__spreadValues({}, jsx), {
    name: (0,_resolveComponent_es_js__WEBPACK_IMPORTED_MODULE_2__/* .resolveComponent */ .u)(resolver, jsx.type)
  });
};
const deserializeNode = (data, resolver) => {
  const _a = data, { type: Comp, props: Props } = _a, nodeData = __objRest(_a, ["type", "props"]);
  const isCompAnHtmlElement = Comp !== void 0 && typeof Comp === "string";
  const isCompAUserComponent = Comp !== void 0 && Comp.resolvedName !== void 0;
  (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(
    isCompAnHtmlElement || isCompAUserComponent,
    _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_4__/* .ERROR_DESERIALIZE_COMPONENT_NOT_IN_RESOLVER.replace */ .aP.replace(
      "%displayName%",
      data.displayName
    ).replace("%availableComponents%", Object.keys(resolver).join(", "))
  );
  const { type, name, props } = deserializeComp(
    data,
    resolver
  );
  const { parent, custom, displayName, isCanvas, nodes, hidden } = nodeData;
  const linkedNodes = nodeData.linkedNodes || nodeData._childCanvas;
  return {
    type,
    name,
    displayName: displayName || name,
    props,
    custom: custom || {},
    isCanvas: !!isCanvas,
    hidden: !!hidden,
    parent,
    linkedNodes: linkedNodes || {},
    nodes: nodes || []
  };
};




/***/ }),

/***/ 395502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ fromEntries; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const fromEntries = (pairs) => {
  if (Object.fromEntries) {
    return Object.fromEntries(pairs);
  }
  return pairs.reduce(
    (accum, [id, value]) => __spreadProps(__spreadValues({}, accum), {
      [id]: value
    }),
    {}
  );
};




/***/ }),

/***/ 633514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getNodesFromSelector; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60599);
/* harmony import */ var tiny_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(668564);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const getNodesFromSelector = (nodes, selector, config) => {
  const items = Array.isArray(selector) ? selector : [selector];
  const mergedConfig = __spreadValues({
    existOnly: false,
    idOnly: false
  }, config || {});
  const nodeSelectors = items.filter((item) => !!item).map((item) => {
    if (typeof item === "string") {
      return {
        node: nodes[item],
        exists: !!nodes[item]
      };
    }
    if (typeof item === "object" && !mergedConfig.idOnly) {
      const node = item;
      return {
        node,
        exists: !!nodes[node.id]
      };
    }
    return {
      node: null,
      exists: false
    };
  });
  if (mergedConfig.existOnly) {
    (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
      nodeSelectors.filter((selector2) => !selector2.exists).length === 0,
      _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_INVALID_NODEID */ .YN
    );
  }
  return nodeSelectors;
};




/***/ }),

/***/ 606494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ mergeTrees; }
/* harmony export */ });
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const mergeNodes = (rootNode, childrenNodes) => {
  if (childrenNodes.length < 1) {
    return { [rootNode.id]: rootNode };
  }
  const nodes = childrenNodes.map(({ rootNodeId }) => rootNodeId);
  const nodeWithChildren = __spreadProps(__spreadValues({}, rootNode), { data: __spreadProps(__spreadValues({}, rootNode.data), { nodes }) });
  const rootNodes = { [rootNode.id]: nodeWithChildren };
  return childrenNodes.reduce((accum, tree) => {
    const currentNode = tree.nodes[tree.rootNodeId];
    return __spreadProps(__spreadValues(__spreadValues({}, accum), tree.nodes), {
      [currentNode.id]: __spreadProps(__spreadValues({}, currentNode), {
        data: __spreadProps(__spreadValues({}, currentNode.data), {
          parent: rootNode.id
        })
      })
    });
  }, rootNodes);
};
const mergeTrees = (rootNode, childrenNodes) => ({
  rootNodeId: rootNode.id,
  nodes: mergeNodes(rootNode, childrenNodes)
});




/***/ }),

/***/ 238636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ parseNodeFromJSX; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _createNode_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(886968);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function parseNodeFromJSX(jsx, normalize) {
  let element = jsx;
  if (typeof element === "string") {
    element = react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}, element);
  }
  const actualType = element.type;
  return (0,_createNode_es_js__WEBPACK_IMPORTED_MODULE_1__/* .createNode */ .d)(
    {
      data: {
        type: actualType,
        props: __spreadValues({}, element.props)
      }
    },
    (node) => {
      if (normalize) {
        normalize(node, element);
      }
    }
  );
}




/***/ }),

/***/ 973818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ removeNodeFromEvents; }
/* harmony export */ });
const removeNodeFromEvents = (state, nodeId) => Object.keys(state.events).forEach((key) => {
  const eventSet = state.events[key];
  if (eventSet && eventSet.has && eventSet.has(nodeId)) {
    state.events[key] = new Set(
      Array.from(eventSet).filter((id) => nodeId !== id)
    );
  }
});




/***/ }),

/***/ 798154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ resolveComponent; }
/* harmony export */ });
/* harmony import */ var _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60599);
/* harmony import */ var tiny_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(668564);



let CACHED_RESOLVER_DATA = null;
const getReversedResolver = (resolver) => {
  if (CACHED_RESOLVER_DATA && CACHED_RESOLVER_DATA.resolver === resolver) {
    return CACHED_RESOLVER_DATA.reversed;
  }
  CACHED_RESOLVER_DATA = {
    resolver,
    reversed: /* @__PURE__ */ new Map()
  };
  for (const [name, comp] of Object.entries(resolver)) {
    CACHED_RESOLVER_DATA.reversed.set(comp, name);
  }
  return CACHED_RESOLVER_DATA.reversed;
};
const getComponentName = (component) => {
  return component.name || component.displayName;
};
const searchComponentInResolver = (resolver, comp) => {
  const name = getReversedResolver(resolver).get(comp);
  return name !== void 0 ? name : null;
};
const resolveComponent = (resolver, comp) => {
  if (typeof comp === "string") {
    return comp;
  }
  const resolvedName = searchComponentInResolver(resolver, comp);
  (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
    resolvedName,
    _tempi_dnd_utils__WEBPACK_IMPORTED_MODULE_1__/* .ERROR_NOT_IN_RESOLVER.replace */ .Wt.replace("%node_type%", getComponentName(comp))
  );
  return resolvedName;
};




/***/ }),

/***/ 832760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ serializeNode; }
/* harmony export */ });
/* unused harmony export serializeComp */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _resolveComponent_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(798154);



var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const reduceType = (type, resolver) => {
  if (typeof type === "string") {
    return type;
  }
  return { resolvedName: (0,_resolveComponent_es_js__WEBPACK_IMPORTED_MODULE_1__/* .resolveComponent */ .u)(resolver, type) };
};
const serializeComp = (data, resolver) => {
  let { props } = data;
  const { type, isCanvas } = data;
  props = Object.keys(props).reduce((result, key) => {
    const prop = props[key];
    if (prop === void 0 || prop === null || typeof prop === "function") {
      return result;
    }
    if (key === "children" && typeof prop !== "string") {
      result[key] = react__WEBPACK_IMPORTED_MODULE_0__.Children.map(prop, (child) => {
        if (typeof child === "string") {
          return child;
        }
        return serializeComp(child, resolver);
      });
    } else if (typeof prop.type === "function") {
      result[key] = serializeComp(prop, resolver);
    } else {
      result[key] = prop;
    }
    return result;
  }, {});
  return {
    type: reduceType(type, resolver),
    isCanvas: !!isCanvas,
    props
  };
};
const serializeNode = (data, resolver) => {
  const _a = data, { type, props, isCanvas, name } = _a, nodeData = __objRest(_a, ["type", "props", "isCanvas", "name"]);
  const reducedComp = serializeComp({ type, isCanvas, props }, resolver);
  return __spreadValues(__spreadValues({}, reducedComp), nodeData);
};




/***/ }),

/***/ 150179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mo": function() { return /* binding */ expectEditorState; },
/* harmony export */   "fj": function() { return /* binding */ createTestNodes; },
/* harmony export */   "yY": function() { return /* binding */ createTestState; }
/* harmony export */ });
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(630839);
/* harmony import */ var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _createNode_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(886968);
/* harmony import */ var _editor_store_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(185105);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getTestNode = (parentNode) => {
  const _a = parentNode, {
    events,
    data: { nodes: childNodes, linkedNodes }
  } = _a, restParentNode = __objRest(_a, [
    "events",
    "data"
  ]);
  const validParentNode = (0,_createNode_es_js__WEBPACK_IMPORTED_MODULE_1__/* .createNode */ .d)(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_0___default()(parentNode));
  parentNode = __spreadProps(__spreadValues(__spreadValues({}, validParentNode), restParentNode), {
    events: __spreadValues(__spreadValues({}, validParentNode.events), events),
    dom: parentNode.dom || validParentNode.dom
  });
  return {
    node: parentNode,
    childNodes,
    linkedNodes
  };
};
const expectEditorState = (lhs, rhs) => {
  const _a = rhs, { nodes: nodesRhs } = _a, restRhs = __objRest(_a, ["nodes"]);
  const _b = lhs, { nodes: nodesLhs } = _b, restLhs = __objRest(_b, ["nodes"]);
  expect(restLhs).toEqual(restRhs);
  const nodesRhsSimplified = Object.keys(nodesRhs).reduce((accum, id) => {
    const _a2 = nodesRhs[id], node = __objRest(_a2, ["_hydrationTimestamp", "rules"]);
    accum[id] = node;
    return accum;
  }, {});
  const nodesLhsSimplified = Object.keys(nodesLhs).reduce((accum, id) => {
    const _a2 = nodesLhs[id], node = __objRest(_a2, ["_hydrationTimestamp", "rules"]);
    accum[id] = node;
    return accum;
  }, {});
  expect(nodesLhsSimplified).toEqual(nodesRhsSimplified);
};
const createTestNodes = (rootNode) => {
  const nodes = {};
  const iterateNodes = (testNode) => {
    const { node: parentNode, childNodes, linkedNodes } = getTestNode(testNode);
    nodes[parentNode.id] = parentNode;
    if (childNodes) {
      childNodes.forEach((childTestNode, i) => {
        const {
          node: childNode,
          childNodes: grandChildNodes,
          linkedNodes: grandChildLinkedNodes
        } = getTestNode(childTestNode);
        childNode.data.parent = parentNode.id;
        nodes[childNode.id] = childNode;
        parentNode.data.nodes[i] = childNode.id;
        iterateNodes(__spreadProps(__spreadValues({}, childNode), {
          data: __spreadProps(__spreadValues({}, childNode.data), {
            nodes: grandChildNodes || [],
            linkedNodes: grandChildLinkedNodes || {}
          })
        }));
      });
    }
    if (linkedNodes) {
      Object.keys(linkedNodes).forEach((linkedId) => {
        const {
          node: childNode,
          childNodes: grandChildNodes,
          linkedNodes: grandChildLinkedNodes
        } = getTestNode(linkedNodes[linkedId]);
        parentNode.data.linkedNodes[linkedId] = childNode.id;
        childNode.data.parent = parentNode.id;
        nodes[childNode.id] = childNode;
        iterateNodes(__spreadProps(__spreadValues({}, childNode), {
          data: __spreadProps(__spreadValues({}, childNode.data), {
            nodes: grandChildNodes || [],
            linkedNodes: grandChildLinkedNodes || {}
          })
        }));
      });
    }
  };
  iterateNodes(rootNode);
  return nodes;
};
const createTestState = (state = {}) => {
  const { nodes: rootNode, events } = state;
  return __spreadProps(__spreadValues(__spreadValues({}, _editor_store_es_js__WEBPACK_IMPORTED_MODULE_2__/* .editorInitialState */ .OI), state), {
    nodes: rootNode ? createTestNodes(rootNode) : {},
    events: __spreadValues(__spreadValues({}, _editor_store_es_js__WEBPACK_IMPORTED_MODULE_2__/* .editorInitialState.events */ .OI.events), events || {})
  });
};




/***/ }),

/***/ 152298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ s; }
/* harmony export */ });
/* harmony import */ var _EventHandlers_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(958050);
/* harmony import */ var _interfaces_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(751277);
class s extends _EventHandlers_es_js__WEBPACK_IMPORTED_MODULE_0__/* .EventHandlers */ .o{constructor(e,s){super(s),this.derived=e,this.options=s,this.unsubscribeParentHandlerListener=this.derived.listen((e=>{switch(e){case _interfaces_es_js__WEBPACK_IMPORTED_MODULE_1__/* .EventHandlerUpdates.HandlerEnabled */ .q.HandlerEnabled:return this.enable();case _interfaces_es_js__WEBPACK_IMPORTED_MODULE_1__/* .EventHandlerUpdates.HandlerDisabled */ .q.HandlerDisabled:return this.disable();default:return}}))}inherit(e){return this.createProxyHandlers(this.derived,e)}cleanup(){super.cleanup(),this.unsubscribeParentHandlerListener()}}


/***/ }),

/***/ 958050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ b; }
});

// EXTERNAL MODULE: ../../.yarn/cache/shallowequal-npm-1.1.0-6688d419cb-f4c1de0837.zip/node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(888661);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/getRandomId.es.js
var getRandomId_es = __webpack_require__(596301);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/EventHandlers/ConnectorRegistry.es.js
class ConnectorRegistry_es_r{constructor(){this.isEnabled=!0,this.elementIdMap=new WeakMap,this.registry=new Map}getElementId(e){const r=this.elementIdMap.get(e);if(r)return r;const s=(0,getRandomId_es/* getRandomId */.w)();return this.elementIdMap.set(e,s),s}getConnectorId(e,t){return`${t}--${this.getElementId(e)}`}register(t,r){const s=this.getByElement(t,r.name);if(s){if(shallowequal_default()(r.required,s.required))return s;this.getByElement(t,r.name).disable()}let i=null;const n=this.getConnectorId(t,r.name);return this.registry.set(n,{id:n,required:r.required,enable:()=>{i&&i(),i=r.connector(t,r.required,r.options)},disable:()=>{i&&i()},remove:()=>this.remove(n)}),this.isEnabled&&this.registry.get(n).enable(),this.registry.get(n)}get(e){return this.registry.get(e)}remove(e){const t=this.get(e);t&&(t.disable(),this.registry.delete(t.id))}enable(){this.isEnabled=!0,this.registry.forEach((e=>{e.enable()}))}disable(){this.isEnabled=!1,this.registry.forEach((e=>{e.disable()}))}getByElement(e,t){return this.get(this.getConnectorId(e,t))}removeByElement(e,t){return this.remove(this.getConnectorId(e,t))}clear(){this.disable(),this.elementIdMap=new WeakMap,this.registry=new Map}}

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/EventHandlers/interfaces.es.js
var interfaces_es = __webpack_require__(751277);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/EventHandlers/isEventBlockedByDescendant.es.js
function t(t,n,o){t.craft||(t.craft={stopPropagation:()=>{},blockedEvents:{}});const r=t.craft&&t.craft.blockedEvents[n]||[];for(let t=0;t<r.length;t++){const n=r[t];if(o!==n&&o.contains(n))return!0}return!1}

;// CONCATENATED MODULE: ../../.yarn/__virtual__/@tempi-dnd-utils-virtual-57d8f5a2bd/0/cache/@tempi-dnd-utils-npm-1.6.1-UX4BUYER-8801.0-c01ba04638-79fa555d44.zip/node_modules/@tempi/dnd-utils/dist/EventHandlers/EventHandlers.es.js
var s=Object.defineProperty,n=Object.defineProperties,i=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,c=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,l=(e,r,t)=>r in e?s(e,r,{enumerable:!0,configurable:!0,writable:!0,value:t}):e[r]=t;class b{constructor(r){this.registry=new ConnectorRegistry_es_r,this.subscribers=new Set,this.options=r}listen(e){return this.subscribers.add(e),()=>this.subscribers.delete(e)}disable(){this.onDisable&&this.onDisable(),this.registry.disable(),this.subscribers.forEach((e=>{e(interfaces_es/* EventHandlerUpdates.HandlerDisabled */.q.HandlerDisabled)}))}enable(){this.onEnable&&this.onEnable(),this.registry.enable(),this.subscribers.forEach((e=>{e(interfaces_es/* EventHandlerUpdates.HandlerEnabled */.q.HandlerEnabled)}))}cleanup(){this.disable(),this.subscribers.clear(),this.registry.clear()}addCraftEventListener(e,r,s,n){const i=n=>{t(n,r,e)||(n.craft.stopPropagation=()=>{n.craft.blockedEvents[r]||(n.craft.blockedEvents[r]=[]),n.craft.blockedEvents[r].push(e)},s(n))};return e.addEventListener(r,i,n),()=>e.removeEventListener(r,i,n)}createConnectorsUsage(){const e=this.handlers(),r=new Set;let t=!1;const s=new Map;return{connectors:Object.entries(e).reduce(((e,[b,h])=>{return d=((e,r)=>{for(var t in r||(r={}))c.call(r,t)&&l(e,t,r[t]);if(o)for(var t of o(r))a.call(r,t)&&l(e,t,r[t]);return e})({},e),n(d,i({[b]:(e,n,i)=>{const o=()=>{const t=this.registry.register(e,{required:n,name:b,options:i,connector:h});return r.add(t.id),t};return s.set(this.registry.getConnectorId(e,b),o),t&&o(),e}}));var d}),{}),register:()=>{t=!0,s.forEach((e=>{e()}))},cleanup:()=>{t=!1,r.forEach((e=>this.registry.remove(e)))}}}derive(e,r){return new e(this,r)}createProxyHandlers(e,r){const t=[],s=e.handlers();return r(new Proxy(s,{get:(e,r,n)=>r in s==0?Reflect.get(e,r,n):(e,...n)=>{const i=s[r](e,...n);i&&t.push(i)}})),()=>{t.forEach((e=>{e()}))}}reflect(e){return this.createProxyHandlers(this,e)}}


/***/ }),

/***/ 751277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ a; }
/* harmony export */ });
var a=(a=>(a[a.HandlerDisabled=0]="HandlerDisabled",a[a.HandlerEnabled=1]="HandlerEnabled",a))(a||{});


/***/ }),

/***/ 786342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ c; }
/* harmony export */ });
/* unused harmony exports cloneWithRef, wrapHookToRecognizeElement */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var tiny_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(668564);
function n(t,r){r&&("function"==typeof t?t(r):t.current=r)}function o(r,o){const i=r.ref;return (0,tiny_invariant__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("string"!=typeof i,"Cannot connect to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute"),(0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(r,i?{ref:t=>{n(i,t),n(o,t)}}:{ref:o})}function i(t){return(e=null,...n)=>{if(!(0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(e)){if(!e)return;const r=e;return r&&t(r,...n),r}const i=e;return function(t){if("string"!=typeof t.type)throw new Error}(i),o(i,t)}}function c(t){return Object.keys(t).reduce(((r,e)=>(r[e]=i(((...r)=>t[e](...r))),r)),{})}


/***/ }),

/***/ 157658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ i; },
/* harmony export */   "G": function() { return /* binding */ e; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(918265);
const e={UNDO:"HISTORY_UNDO",REDO:"HISTORY_REDO",THROTTLE:"HISTORY_THROTTLE",IGNORE:"HISTORY_IGNORE",MERGE:"HISTORY_MERGE",CLEAR:"HISTORY_CLEAR"};class i{constructor(){this.timeline=[],this.pointer=-1}add(t,e){0===t.length&&0===e.length||(this.pointer=this.pointer+1,this.timeline.length=this.pointer,this.timeline[this.pointer]={patches:t,inversePatches:e,timestamp:Date.now()})}throttleAdd(t,e,i=500){if(0!==t.length||0!==e.length){if(this.timeline.length&&this.pointer>=0){const{patches:n,inversePatches:s,timestamp:h}=this.timeline[this.pointer];if((new Date).getTime()-h<i)return void(this.timeline[this.pointer]={timestamp:h,patches:[...n,...t],inversePatches:[...e,...s]})}this.add(t,e)}}merge(t,e){if(0!==t.length||0!==e.length)if(this.timeline.length&&this.pointer>=0){const{patches:i,inversePatches:n,timestamp:s}=this.timeline[this.pointer];this.timeline[this.pointer]={timestamp:s,patches:[...i,...t],inversePatches:[...e,...n]}}else this.add(t,e)}clear(){this.timeline=[],this.pointer=-1}canUndo(){return this.pointer>=0}canRedo(){return this.pointer<this.timeline.length-1}undo(e){if(!this.canUndo())return;const{inversePatches:i}=this.timeline[this.pointer];return this.pointer=this.pointer-1,(0,immer__WEBPACK_IMPORTED_MODULE_0__/* .applyPatches */ .QE)(e,i)}redo(e){if(!this.canRedo())return;this.pointer=this.pointer+1;const{patches:i}=this.timeline[this.pointer];return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* .applyPatches */ .QE)(e,i)}}


/***/ }),

/***/ 748357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(926759);
var o=Object.defineProperty,t=Object.getOwnPropertySymbols,n=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable,l=(r,e,t)=>e in r?o(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t,p=(r,e)=>{for(var o in e||(e={}))n.call(e,o)&&l(r,o,e[o]);if(t)for(var o of t(e))a.call(e,o)&&l(r,o,e[o]);return r};const c=({style:o,parentDom:t})=>{const n=(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div",{style:p({position:"fixed",display:"block",opacity:1,borderStyle:"solid",borderWidth:"1px",borderColor:"transparent",zIndex:99999},o)});return t&&t.ownerDocument!==document?react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(n,t.ownerDocument.body):n};


/***/ }),

/***/ 60599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CD": function() { return /* binding */ n; },
/* harmony export */   "Cz": function() { return /* binding */ c; },
/* harmony export */   "JB": function() { return /* binding */ E; },
/* harmony export */   "Ph": function() { return /* binding */ l; },
/* harmony export */   "QS": function() { return /* binding */ e; },
/* harmony export */   "UE": function() { return /* binding */ t; },
/* harmony export */   "Ut": function() { return /* binding */ g; },
/* harmony export */   "VW": function() { return /* binding */ a; },
/* harmony export */   "Wt": function() { return /* binding */ f; },
/* harmony export */   "YN": function() { return /* binding */ i; },
/* harmony export */   "ZW": function() { return /* binding */ C; },
/* harmony export */   "aL": function() { return /* binding */ s; },
/* harmony export */   "aP": function() { return /* binding */ y; },
/* harmony export */   "ab": function() { return /* binding */ o; },
/* harmony export */   "iO": function() { return /* binding */ v; },
/* harmony export */   "if": function() { return /* binding */ d; },
/* harmony export */   "k8": function() { return /* binding */ N; },
/* harmony export */   "lq": function() { return /* binding */ b; },
/* harmony export */   "pY": function() { return /* binding */ x; },
/* harmony export */   "sS": function() { return /* binding */ m; },
/* harmony export */   "sk": function() { return /* binding */ p; }
/* harmony export */ });
/* unused harmony exports ERROR_INFINITE_CANVAS, ERROR_MISSING_PLACEHOLDER_PLACEMENT, ERROR_MOVE_ROOT_NODE */
const e="ROOT",n="canvas-ROOT",o="Parent id cannot be ommited",t="Attempting to add a node with duplicated id",i="Node does not exist, it may have been removed",a='A <Element /> that is used inside a User Component must specify an `id` prop, eg: <Element id="text_element">...</Element> ',r="Placeholder required placement info (parent, index, or where) is missing",d="Node cannot be dropped into target parent",s="Target parent rejects incoming node",p="Current parent rejects outgoing node",c="Cannot move node that is not a direct child of a Canvas node",l="Cannot move node into a non-Canvas parent",m="A top-level Node cannot be moved",h="Root Node cannot be moved",v="Cannot move node into a descendant",f="The component type specified for this node (%node_type%) does not exist in the resolver",u="The component specified in the <Canvas> `is` prop has additional Canvas specified in it's render template.",g="The node has specified a canDrag() rule that prevents it from being dragged",C="Invalid parameter Node Id specified",E="Attempting to delete a top-level Node",b="Resolver in <Editor /> has to be an object. For (de)serialization Craft.js needs a list of all the User Components. \n    \nMore info: https://craft.js.org/r/docs/api/editor#props",y="An Error occurred while deserializing components: Cannot find component <%displayName% /> in resolver map. Please check your resolver in <Editor />\n\nAvailable components in resolver: %availableComponents%\n\nMore info: https://craft.js.org/r/docs/api/editor#props",N="You can only use useEditor in the context of <Editor />. \n\nPlease only use useEditor in components that are children of the <Editor /> component.",x="You can only use useNode in the context of <Editor />. \n\nPlease only use useNode in components that are children of the <Editor /> component.";


/***/ }),

/***/ 182052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ e; }
/* harmony export */ });
const e=(e,s)=>{let t=`Deprecation warning: ${e} will be deprecated in future relases.`;const{suggest:n,doc:a}=s;n&&(t+=` Please use ${n} instead.`),a&&(t+=`(${a})`)};


/***/ }),

/***/ 914785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ t; }
/* harmony export */ });
const t=t=>{const{x:e,y:i,top:o,left:n,bottom:a,right:r,width:s,height:d}=t.getBoundingClientRect(),l=null==window?void 0:window.getComputedStyle(t),p={left:parseInt(l.marginLeft),right:parseInt(l.marginRight),bottom:parseInt(l.marginBottom),top:parseInt(l.marginTop)},g={left:parseInt(l.paddingLeft),right:parseInt(l.paddingRight),bottom:parseInt(l.paddingBottom),top:parseInt(l.paddingTop)};return{x:e,y:i,top:o,left:n,bottom:a,right:r,width:s,height:d,outerWidth:Math.round(s+p.left+p.right),outerHeight:Math.round(d+p.top+p.bottom),margin:p,padding:g,inFlow:t.parentElement&&!!(e=>{const i=null==window?void 0:window.getComputedStyle(e);if(!(l.overflow&&"visible"!==l.overflow||"none"!==i.float||"grid"===i.display||"flex"===i.display&&"column"!==i["flex-direction"])){switch(l.position){case"static":case"relative":break;default:return}switch(t.tagName){case"TR":case"TBODY":case"THEAD":case"TFOOT":return!0}switch(l.display){case"block":case"list-item":case"table":case"flex":case"grid":return!0}}})(t.parentElement)}};


/***/ }),

/***/ 596301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(837375);
const n=(n=10)=>(0,nanoid__WEBPACK_IMPORTED_MODULE_0__/* .nanoid */ .x0)(n);


/***/ }),

/***/ 639705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IJ": function() { return /* binding */ n; },
/* harmony export */   "mJ": function() { return /* binding */ t; }
/* harmony export */ });
/* unused harmony export isClientSide */
const e=()=>"undefined"!=typeof window,n=()=>e()&&/Linux/i.test(window.navigator.userAgent),t=()=>e()&&/Chrome/i.test(window.navigator.userAgent);


/***/ }),

/***/ 35690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
var c=Object.defineProperty,o=Object.defineProperties,u=Object.getOwnPropertyDescriptors,a=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,p=Object.prototype.propertyIsEnumerable,b=(r,e,t)=>e in r?c(r,e,{enumerable:!0,configurable:!0,writable:!0,value:t}):r[e]=t;function l(c,l){const{subscribe:s,getState:y,actions:f,query:O}=c,j=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(!0),m=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(l);v.current=l;const P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((r=>{return e=((r,e)=>{for(var t in e||(e={}))i.call(e,t)&&b(r,t,e[t]);if(a)for(var t of a(e))p.call(e,t)&&b(r,t,e[t]);return r})({},r),o(e,u({actions:f,query:O}));var e}),[f,O]);j.current&&l&&(m.current=l(y(),O),j.current=!1);const[g,w]=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(P(m.current));return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((()=>{let r;return v.current&&(r=s((r=>v.current(r,O)),(r=>{w(P(r))}))),()=>{r&&r()}}),[P,O,s]),g}


/***/ }),

/***/ 360216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ R; }
/* harmony export */ });
/* unused harmony export createQuery */
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(918265);
/* harmony import */ var lodash_isequalwith__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(890166);
/* harmony import */ var lodash_isequalwith__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isequalwith__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _History_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(157658);
var p=Object.defineProperty,y=Object.defineProperties,d=Object.getOwnPropertyDescriptors,b=Object.getOwnPropertySymbols,h=Object.prototype.hasOwnProperty,f=Object.prototype.propertyIsEnumerable,O=(e,t,r)=>t in e?p(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,E=(e,t)=>{for(var r in t||(t={}))h.call(t,r)&&O(e,r,t[r]);if(b)for(var r of b(t))f.call(t,r)&&O(e,r,t[r]);return e},m=(e,t)=>y(e,d(t));function R(t,r,s,p){const y=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>new _History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .History */ .A),[]);let d;const b=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]),h=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();"function"==typeof t?d=t:(d=t.methods,b.current=t.ignoreHistoryForActions,h.current=t.normalizeHistory);const f=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(p);f.current=p;const O=(0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(r),R=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>{const{current:t}=h,{current:r}=b,{current:o}=f;return(n,i)=>{const u=s&&g(s,(()=>n),y);let a,[p,b,h]=(0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produceWithPatches */ .aS)(n,(e=>{switch(i.type){case _History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.UNDO */ .G.UNDO:return y.undo(e);case _History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.REDO */ .G.REDO:return y.redo(e);case _History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.CLEAR */ .G.CLEAR:return y.clear(),E({},e);case _History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.IGNORE */ .G.IGNORE:case _History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.MERGE */ .G.MERGE:case _History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.THROTTLE */ .G.THROTTLE:{const[t,...r]=i.payload;d(e,u)[t](...r);break}default:d(e,u)[i.type](...i.payload)}}));return a=p,o&&o(p,n,{type:i.type,params:i.payload,patches:b},u,(e=>{const t=(0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produceWithPatches */ .aS)(p,e);a=t[0],b=[...b,...t[1]],h=[...t[2],...h]})),[_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.UNDO */ .G.UNDO,_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.REDO */ .G.REDO].includes(i.type)&&t&&(a=(0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(a,t)),[...r,_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.UNDO */ .G.UNDO,_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.REDO */ .G.REDO,_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.IGNORE */ .G.IGNORE,_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.CLEAR */ .G.CLEAR].includes(i.type)||(i.type===_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.THROTTLE */ .G.THROTTLE?y.throttleAdd(b,h,i.config&&i.config.rate):i.type===_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.MERGE */ .G.MERGE?y.merge(b,h):y.add(b,h)),a}}),[y,d,s]),w=(0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((()=>O.current),[]),D=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>new j(w)),[w]),T=(0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e=>{const t=R(O.current,e);O.current=t,D.notify()}),[R,D]);(0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)((()=>{D.notify()}),[D]);const N=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>s?g(s,(()=>O.current),y):[]),[y,s]),C=(0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>{const e=Object.keys(d(null,null)),{current:t}=b;return m(E({},e.reduce(((e,t)=>(e[t]=(...e)=>T({type:t,payload:e}),e)),{})),{history:{undo:()=>T({type:_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.UNDO */ .G.UNDO}),redo:()=>T({type:_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.REDO */ .G.REDO}),clear:()=>T({type:_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.CLEAR */ .G.CLEAR}),throttle:r=>E({},e.filter((e=>!t.includes(e))).reduce(((e,t)=>(e[t]=(...e)=>T({type:_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.THROTTLE */ .G.THROTTLE,payload:[t,...e],config:{rate:r}}),e)),{})),ignore:()=>E({},e.filter((e=>!t.includes(e))).reduce(((e,t)=>(e[t]=(...e)=>T({type:_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.IGNORE */ .G.IGNORE,payload:[t,...e]}),e)),{})),merge:()=>E({},e.filter((e=>!t.includes(e))).reduce(((e,t)=>(e[t]=(...e)=>T({type:_History_es_js__WEBPACK_IMPORTED_MODULE_2__/* .HISTORY_ACTIONS.MERGE */ .G.MERGE,payload:[t,...e]}),e)),{}))}})}),[T,d]);return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)((()=>({getState:w,subscribe:(e,t,r)=>D.subscribe(e,t,r),actions:C,query:N,history:y})),[C,N,D,w,y])}function g(e,t,r){const c=Object.keys(e()).reduce(((r,c)=>m(E({},r),{[c]:(...r)=>e(t())[c](...r)})),{});return m(E({},c),{history:{canUndo:()=>r.canUndo(),canRedo:()=>r.canRedo()}})}(0,immer__WEBPACK_IMPORTED_MODULE_3__/* .enableMapSet */ .MD)(),(0,immer__WEBPACK_IMPORTED_MODULE_3__/* .enablePatches */ .vI)();class j{constructor(e){this.subscribers=[],this.getState=e}subscribe(e,t,r){const c=new w((()=>e(this.getState())),t,r);return this.subscribers.push(c),this.unsubscribe.bind(this,c)}unsubscribe(e){if(this.subscribers.length){const t=this.subscribers.indexOf(e);if(t>-1)return this.subscribers.splice(t,1)}}notify(){this.subscribers.forEach((e=>e.collect()))}}class w{constructor(e,t,r=!1){this.collector=e,this.onChange=t,r&&this.collect()}collect(){try{const e=this.collector();lodash_isequalwith__WEBPACK_IMPORTED_MODULE_0___default()(e,this.collected)||(this.collected=e,this.onChange&&this.onChange(this.collected))}catch(e){}}}


/***/ })

}]);